import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  label: 'BONO 1',
  title: 'Guía de Suplementación Inteligente',
  highlight: 'Vitaminas y minerales que realmente apoyan tu tiroides',
  desc: 'Olvidate de gastar plata en suplementos que no sirven. Esta guía te muestra cuáles son los nutrientes esenciales para tu tiroides, en qué dosis tomarlos, en qué momento del día y qué combinaciones evitar para no anular su efecto. Información clara, basada en evidencia y adaptada al mercado argentino.',
  quote: '“Saber qué tomar y cuándo cambió mi energía por completo. Por fin entendí qué necesitaba mi cuerpo.”',
  value: 14990,
  image: 'https://cdn.shopify.com/s/files/1/0829/1431/2411/files/BONO1_Guia_de_suplementacion.png?v=1779798823'
}, {
  label: 'BONO 2',
  title: 'Planificador Semanal Imprimible',
  highlight: 'Organizá toda tu semana en menos de 5 minutos',
  desc: 'Plantillas listas para imprimir y pegar en tu heladera. Incluye planificador de menú semanal, lista de compras pre-armada y un tracker de hábitos saludables. Cero excusas para improvisar comidas que no te hacen bien: cuando tenés todo planeado, todo fluye.',
  quote: '“Empecé a planificar mis comidas el domingo a la noche y cambió mi semana entera. Cero estrés, cero atracones.”',
  value: 9990,
  image: 'https://cdn.shopify.com/s/files/1/0829/1431/2411/files/BONO2_PLANIFICADOR_IMPRIMIBLE.png?v=1779798823'
}];
const formatARS = (n: number) => `$${n.toLocaleString('es-AR')}`;
export const BonusShowcase = () => {
  return <section className="py-16 md:py-24 bg-stone-50" data-id="element-44">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-45">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-46">
          <span className="inline-block text-accent-600 font-bold tracking-wider uppercase text-sm mb-3" data-id="element-47">
            Regalos exclusivos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-48">
            Además, te llevás estos 2 bonos de regalo
          </h2>
          <p className="text-lg text-stone-600" data-id="element-49">
            Diseñados para potenciar tus resultados desde el primer día. Sin
            costo adicional.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-50">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.label} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1,
          ease: 'easeOut'
        }} className="relative rounded-3xl p-8 md:p-10 bg-brand-900 border border-amber-400/40 shadow-2xl overflow-hidden flex flex-col" data-id="element-51">
              {/* Decorative glow */}
              <div className="absolute -top-20 -right-20 w-60 h-60 bg-amber-400/10 rounded-full blur-3xl pointer-events-none" data-id="element-52" />

              {/* Free badge */}
              <div className="absolute top-5 right-5 bg-amber-400 text-brand-900 text-xs font-extrabold px-3 py-1 rounded-full uppercase tracking-wider shadow-lg z-10" data-id="element-53">
                Gratis
              </div>

              {/* Bonus image — top centered */}
              <div className="relative flex justify-center mb-6" data-id="element-54">
                <div className="w-44 h-44 md:w-52 md:h-52 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 flex items-center justify-center p-4 shadow-xl" data-id="element-55">
                  <img src={`${bonus.image}&width=400&quality=80&format=webp`} alt={bonus.title} width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-56" />
                </div>
              </div>

              {/* Bonus label */}
              <p className="text-center text-amber-400 font-bold tracking-[0.2em] text-sm mb-3" data-id="element-57">
                {bonus.label}
              </p>

              {/* Title */}
              <h3 className="text-center text-2xl md:text-3xl font-bold text-white mb-5 leading-tight" data-id="element-58">
                {bonus.title}
              </h3>

              {/* Highlight subtitle */}
              <p className="font-serif italic text-lg text-amber-200/90 mb-5 leading-snug" data-id="element-59">
                {bonus.highlight}
              </p>

              {/* Description */}
              <p className="text-stone-300 leading-relaxed mb-6 flex-1" data-id="element-60">
                {bonus.desc}
              </p>

              {/* Quote box */}
              <div className="bg-brand-800/60 border border-brand-700/40 rounded-xl p-5 mb-6" data-id="element-61">
                <p className="font-serif italic text-stone-200 text-sm leading-relaxed" data-id="element-62">
                  {bonus.quote}
                </p>
              </div>

              {/* Value strip */}
              <div className="flex items-center justify-between pt-5 border-t border-white/10" data-id="element-63">
                <span className="text-stone-400 text-sm uppercase tracking-wider font-medium" data-id="element-64">
                  Valor normal
                </span>
                <div className="text-right" data-id="element-65">
                  <span className="text-stone-400 text-base line-through mr-2" data-id="element-66">
                    {formatARS(bonus.value)}
                  </span>
                  <span className="text-amber-400 font-extrabold text-lg" data-id="element-67">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};